import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, Alert } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DefaultOutlinedButton, DefaultContainedButton } from './Buttons';
import { CustomDatePicker, CustomTextField } from './StyledInputs';

import API from '../api';
import { HttpErrorHandler } from './ErrorHandler';
import { usePopup } from '../context/PopupContext';

dayjs.locale('it');

export const EditPositionDialog = ({
  openDialog,
  closeDialog,
  userAuth,
  userInfo,
  positionToEdit,
  setPositionToEdit,
  refreshFunction,
}) => {
  const { showPopup, setPopUpText } = usePopup();


  const [positionToEditStartDate, setPositionToEditStartDate] = useState('');
  const [positionToEditEndDate, setPositionToEditEndDate] = useState('');
  const [positionToEditEmail, setPositionToEditEmail] = useState('');

  useEffect(() => {
    if (Object.keys(positionToEdit).length > 0) {
      setPositionToEditEmail(positionToEdit.email);

      const startDate = dayjs(positionToEdit.start_date).format('YYYY/MM/DD');
      setPositionToEditStartDate(startDate);

      const endDate = dayjs(positionToEdit.end_date).format('YYYY/MM/DD');
      setPositionToEditEndDate(endDate);
    }
  }, [positionToEdit]);

  const emptyField = () => {
    closeDialog();
    setPositionToEdit({});
    setPositionToEditEmail('');
    setPositionToEditStartDate('');
    setPositionToEditEndDate('');
  };

  // Position Edit Start Date
  const handleEditPositionStartDate = (date) => {
    setPositionToEditStartDate(date);
  };
  // Position Edit End Date
  const handleEditPositionEndDate = (date) => {
    setPositionToEditEndDate(date);
  };

  // Edit Position
  const editPosition = (e) => {
    e.preventDefault();

    const positionEditData = {
      user_id: userInfo.id,
      position_id: positionToEdit.position_id,
      start_date: dayjs(positionToEditStartDate).format('YYYY/MM/DD'),
    };

    let itemsLeft = false;

    Object.keys(positionEditData).forEach((key) => {
      const value = positionEditData[key];

      if (Object.prototype.hasOwnProperty.call(positionEditData, key)) {
        if (
          value === undefined ||
          value === null ||
          value === 'Invalid Date' ||
          (typeof value === 'string' && value.length === 0)
        ) {
          itemsLeft = true;
          showPopup('warning', 'Inserisci i dati mancanti');
        }
      }
    });

    if (!itemsLeft) {
      if (
        positionToEditEndDate !== '' &&
        positionToEditEndDate !== 'Invalid Date' &&
        positionToEditEndDate !== null &&
        positionToEditEndDate !== undefined
      ) {
        positionEditData.end_date = dayjs(positionToEditEndDate).format('YYYY/MM/DD');
      } else {
        positionEditData.end_date = null;
      }

      if (
        positionToEditEmail !== '' &&
        positionToEditEmail !== null &&
        positionToEditEmail !== undefined &&
        positionToEditEmail.length > 0
      ) {
        positionEditData.email = positionToEditEmail;
      } else {
        positionEditData.email = '';
      }

      if (positionEditData.end_date) {
        if (dayjs(positionEditData.end_date).isAfter(dayjs(positionEditData.start_date))) {
          API.put(`/charges/${positionToEdit.id}`, positionEditData)
            .then((response) => {
              emptyField();
              refreshFunction();
            })
            .catch((error) => {
              HttpErrorHandler(error, setPopUpText);
              showPopup(false);
            });
        } else {
          showPopup(false, 'La data di fine non può essere antecedente a quella di inizio');
        }
      } else {
        API.put(`/charges/${positionToEdit.id}`, positionEditData)
          .then((response) => {
            emptyField();
            refreshFunction();
          })
          .catch((error) => {
            HttpErrorHandler(error, setPopUpText);
            showPopup(false);
          });
      }
    }
  };

  return (
    <Dialog fullWidth open={openDialog} onClose={() => {}}>
      <DialogTitle sx={{ textAlign: 'center' }}>Modifica Carica</DialogTitle>

      <form onSubmit={editPosition}>
        <DialogContent>
          <Grid container spacing={3}>
            {/* Position Name */}
            <Grid item xs={12}>
              <CustomTextField
                InputProps={{
                  readOnly: true,
                }}
                label="Carica"
                defaultValue={positionToEdit.name}
              />
            </Grid>

            {positionToEdit.internal === 0 ? (
              <Grid item xs={12}>
                <Alert severity="error" sx={{ marginBottom: '8px' }}>
                  Attenzione! Inserire esclusivamente una email istituzionale, questa sarà visible all'interno
                  dell'organizzazione.
                </Alert>
                <CustomTextField
                  type="email"
                  label="Email Istituzionale"
                  onChange={(e) => setPositionToEditEmail(e.currentTarget.value)}
                  value={positionToEditEmail}
                />
              </Grid>
            ) : (
              <Grid item xs={12}>
                <CustomTextField
                  InputProps={{
                    readOnly: true,
                  }}
                  label="Entità"
                  value={'Nome Entità'}
                />
              </Grid>
            )}

            {/* Start Date */}
            <Grid item xs={12} md={6} sx={{ overflow: 'auto' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <CustomDatePicker
                  required
                  label="Data Inizio Carica *"
                  defaultValue={positionToEdit.start_date ? dayjs(positionToEdit.start_date) : null}
                  onChange={handleEditPositionStartDate}
                  maxDate={dayjs(positionToEditEndDate)}
                />
              </LocalizationProvider>
            </Grid>
            {/* End Date */}
            <Grid item xs={12} md={6} sx={{ overflow: 'auto' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <CustomDatePicker
                  required
                  label="Data Fine Carica"
                  defaultValue={positionToEdit.end_date ? dayjs(positionToEdit.end_date) : null}
                  onChange={handleEditPositionEndDate}
                  minDate={dayjs(positionToEditStartDate)}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <DefaultOutlinedButton onClick={closeDialog}>Annulla</DefaultOutlinedButton>

          <DefaultContainedButton type="submit">Salva</DefaultContainedButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};
